import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ReportRepositoryImpl } from "../../data/repository/report_repository_impl";
import { ReportCategoryInterface } from "../interface/report_category_interface";

export const useGetReportCategories = () => {
    const repository = new ReportRepositoryImpl();

    return useQuery<ReportCategoryInterface[] | null, AxiosError>({
        queryKey: ['reportCategories'],
        queryFn: () => repository.getReportCategories(),
        retry: 2,
        staleTime: 15 * 60 * 1000,
        gcTime: 60 * 60 * 1000,
    });
};